export default {
	notFound: "Not Found",
	selectAll: "Select All",
	unselectAll: "Unselect All",
	selectedItems: "selected items"
};